import React from 'react';

const UysotIcon = ({ pathFill = '#142824', size = 30 }: { pathFill?: string; size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.17944 26.2438C3.17944 24.8283 4.34238 23.6807 5.77697 23.6807H24.8255C26.2601 23.6807 27.423 24.8283 27.423 26.2438C27.423 27.6594 26.2601 28.807 24.8255 28.807H5.77697C4.34238 28.807 3.17944 27.6594 3.17944 26.2438Z"
      fill={pathFill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.6733 0.758995C14.6822 -0.252998 16.3178 -0.252998 17.3267 0.758995L30.2434 13.7158C31.2521 14.7279 31.2521 16.3685 30.2434 17.3805C29.2346 18.3926 27.5989 18.3926 26.5899 17.3805L15.5 6.25611L4.41003 17.3805C3.40117 18.3926 1.7655 18.3926 0.756642 17.3805C-0.252214 16.3685 -0.252214 14.7279 0.756642 13.7158L13.6733 0.758995Z"
      fill={pathFill}
    />
    <path
      d="M19.4575 16.8517C19.4575 19.0504 17.6611 20.8329 15.4451 20.8329C13.229 20.8329 11.4326 19.0504 11.4326 16.8517C11.4326 14.653 13.229 12.8706 15.4451 12.8706C17.6611 12.8706 19.4575 14.653 19.4575 16.8517Z"
      fill="#FF4306"
    />
  </svg>
);

export default UysotIcon;
